/**
 * **Roomsome**
 *
 * @exports bs_384
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    const dataLayer = window.dataLayer;
    /**
       * @memberOf module:bs_384
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            reject('no_language');
        });
    };
    /**
       * @memberOf module:bs_384
       * @see {@link is_user_logged}
       *
       * @param {object} ctx - The context object.
       */
    engine.isUserLogged = function isUserLogged(ctx) {
        const isLogged = false;
        return isLogged;
    };
    /**
       * @memberOf module:bs_384
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        const productData = window.ec_productdata;
        const getPrices = (roomList) => Array.isArray(roomList) && roomList?.map((room) => room?.price).filter(Boolean).sort((a, b) => a - b);
        const dateBeginText = document.querySelector('.rs-offer-arrival')?.textContent;
        const dateEndText = document.querySelector('.rs-offer-departure')?.textContent;
        const dateBeginFromDom = thn.data.language === 'hu' ? dateBeginText?.slice(0, -1)?.replace(/\./g, '/')
            : dateBeginText.replace(/\./g, '/')?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        const dateEndFromDom = thn.data.language === 'hu' ? dateEndText?.slice(0, -1)?.replace(/\./g, '/')
            : dateEndText?.replace(/\./g, '/')?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        // Dates
        let nights;
        const dateBegin = thn.objectGet(dataLayer, 'arrival')?.replace(/-/g, '/') || dateBeginFromDom;
        const dateEnd = thn.objectGet(dataLayer, 'departure')?.replace(/-/g, '/') || dateEndFromDom;
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
            nights = thn.daysBetween(dateBegin, dateEnd) || thn.parseNumber(document.querySelector('.rs-offer-nights')?.textContent);
        }
        // Guests, Adults & Children
        const roomNumber = thn.parseNumber(document.querySelector('#calcres_mainpage > div.mb-5.text-center.rs-info-box.rs-witharrow > p:nth-child(2) > strong')?.textContent);
        const guestFromDom = document.querySelector(`#rs_summary_room_${roomNumber - 1}_persons .rs-summary-room-persons`)?.innerText;
        const adults = thn.parseNumber(guestFromDom) || 2;
        const children = thn.parseNumber(guestFromDom?.split(',')?.[1]) || 0;
        widgetData.adults = adults;
        widgetData.children = children;
        widgetData.guests = adults + children;
        const roomInfo = {
            adults: adults,
            children: children,
            childrenAges: [],
        };
        const childrenAgesArray = document.querySelector(`#rs_summary_room_${roomNumber - 1}_persons .rs-summary-room-persons .text-nowrap`)?.innerText?.split(',');
        // 2: 0y - 2ys | 5: 3ys - 5ys | 11: 6ys - 11ys | 14: 12ys - 14ys | 18: 15ys - 18ys
        for (let i = 0; i < widgetData.children; i += 1) {
            const childAge = thn.parseNumber(childrenAgesArray[i]);
            if (childAge <= 2) {
                roomInfo.childrenAges.push(2);
            }
            else if (childAge <= 5) {
                roomInfo.childrenAges.push(5);
            }
            else if (childAge <= 11) {
                roomInfo.childrenAges.push(11);
            }
            else if (childAge <= 14) {
                roomInfo.childrenAges.push(14);
            }
            else {
                roomInfo.childrenAges.push(18);
            }
        }
        // Prices & Currency || No Rooms
        const dlAvailableRooms = thn.objectGet(dataLayer, 'impressions');
        const priceSelector = document.querySelector('span.rs-price') ? 'span.rs-price' : '.rs-price';
        const domPrices = [...document.querySelectorAll(priceSelector)].map((price) => thn.parseNumber(price?.textContent));
        const currency = thn.objectGet(dataLayer, 'currencyCode') || productData?.currencyCode || thn.parseCurrency(document.querySelector(priceSelector)?.textContent);
        const prices = (dlAvailableRooms && getPrices(dlAvailableRooms)) || (productData && getPrices(Object.values(productData?.productdata))) || domPrices.filter(Boolean).sort((a, b) => a - b);
        const noAvailability = thn.empty(prices);
        if (nights && !thn.empty(prices)) {
            widgetData.price = prices[0] / nights;
            widgetData.currency = currency;
            widgetData.roomsDispo = [roomInfo];
            widgetData.set = true;
        }
        if (noAvailability) {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_384
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const bookingId = thn.objectGet(dataLayer, 'bookingID');
        if (!bookingId) {
            widgetData.set = false;
            return widgetData;
        }
        const price = thn.parseNumber(thn.objectGet(dataLayer, 'payment_details')?.[0]?.payment_value) || thn.parseNumber(thn.objectGet(dataLayer, 'revenue')) || thn.parseNumber(document.querySelector('.rs-summary-price')?.textContent);
        const currency = thn.objectGet(dataLayer, 'currencyCode') || thn.parseCurrency(document.querySelector('.rs-summary-price')?.textContent);
        const dateBegin = thn.objectGet(dataLayer, 'arrival')?.replace(/-/g, '/');
        const dateEnd = thn.objectGet(dataLayer, 'departure')?.replace(/-/g, '/');
        widgetData.bookingId = bookingId;
        widgetData.dateBegin = dateBegin;
        widgetData.dateEnd = dateEnd;
        widgetData.price = price;
        widgetData.currency = currency;
        return widgetData;
    };
    return engine;
}

export { factory };
